'use client';

import Button from '@/components/atoms/Button';
import { passButtonIcons } from '@/components/atoms/Button/utils';
import { LinkButtonStrapiProps } from '@/components/atoms/LinkButton/LinkStrapi';
import { openTermlyPreferences } from '@/lib/termly/TermlyCMP';
import { cn } from '@/lib/utils';
import { mutualLinkStyle } from './Footer';

type Props = {
  link: LinkButtonStrapiProps;
};

const CookiePolicyLink = (props: Props) => {
  return (
    <Button
      as='button'
      classNames={{
        root: cn(mutualLinkStyle, 'hover:bg-transparent active:bg-transparent'),
      }}
      slim={true}
      textWrap={true}
      variant='text'
      onClick={openTermlyPreferences}
      {...passButtonIcons(props.link)}
    >
      {props.link.text}
    </Button>
  );
};

export default CookiePolicyLink;
